import styled from 'styled-components';

export const ButtonsContainer = styled.div`
  gap: 16px;
  display: flex;
  margin-top: 24px;
  justify-content: flex-end;
`;

export const HiddenPasswordInput = styled.input`
  top: -100px;
  left: -100px;
  display: none;
  position: absolute;
`;
